import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

import LocalStorage from "./utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const handleErrorResponse = (error, rejectWithValue) => {
    if (error.response.status === 401) {
          LocalStorage.clear()
        window.location.href = '/login'
    }
    if (error.response.status !== 200) {
        if (error.response.data instanceof ArrayBuffer) {
            const message = new Uint8Array(error.response.data)
            const str = String.fromCharCode.apply(String, message);
            const obj = JSON.parse(str)
            return rejectWithValue({ message: obj.message })
        }
        console.log(error.response.data instanceof ArrayBuffer)
        return rejectWithValue({ message: error.response.data.message })
    }
    return rejectWithValue({message: 'Something went wrong!'})
}

export const erpLogin = createAsyncThunk('erpLogin', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/login`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error?.response?.status !== 200) {
            console.log('error 1', error)
            console.log('error response 1', error.response)
            return rejectWithValue({ message: error.response?.data?.message ?? 'null check failed response' })
        }
        console.log('error 2 ', error)
        console.log('error response 2', error?.response)
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const fetchConfirmedOrders = createAsyncThunk('fetchConfirmedOrders', async (_, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/vendor/get-orders`
    try {
        const response = await axios.post(URL)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getSkuDetails = createAsyncThunk('getSkuDetails', async (boxCount, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/vendor/get-tentative-shipment/${boxCount}`
    try {
        const response = await axios.post(URL)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.mesage })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const saveShipmentDetails = createAsyncThunk('saveShipmentDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/vendor/save-shipment-data`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getNewOrdersData = createAsyncThunk('newOrders', async (_, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/vendor/get-new-orders`
    try {
        const response = await axios.post(URL)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const confirmNewOrder = createAsyncThunk('confirmNewOrder', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/retool/erp/vendor/confirm-order`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.mesage })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getManageShipments = createAsyncThunk('manageShipments', async (_, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/vendor/get-shipments`
    try {
        const response = await axios.post(URL)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const confirmShipment = createAsyncThunk('confirmShipment', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/vendor/confirm-shipment`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.mesage })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getOpsConfirmedOrders = createAsyncThunk('opsConfirmedOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/ops/get-orders/confirmed/${data.pageNumber}`
    try {
        const response = await axios.post(URL, {'page_size': data.page_size})
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getOpsAllPendingOrders = createAsyncThunk('getOpsAllPendingOrders', async (_, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/ops/get-bulk-orders-for-approval`
    try {
        const response = await axios.post(URL)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const placeManualReorders = createAsyncThunk('placeManualReorders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/place-manual-reorder`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data?.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getOpsVendorPendingOrders = createAsyncThunk('getOpsVendorPendingOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/ops/get-orders/pending/${data.pageNumber}`
    try {
        const response = await axios.post(URL, {'page_size': data.page_size})
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const confirmOpsVendorPendingOrders = createAsyncThunk('confirmOpsVendorPendingOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}retool/erp/ops/approve-order`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const myOrders = createAsyncThunk('myOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-orders`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const updateOrders = createAsyncThunk('updateOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/update-orders`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getShippingItems = createAsyncThunk('getShippingItems', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-shipping-items`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const updateShipment = createAsyncThunk('updateShipment', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/update-shipment`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getShipments = createAsyncThunk('getShipments', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-shipments`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getPackingItems = createAsyncThunk('getPackingItems', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-packing-items`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getShippingList = createAsyncThunk('getShippingList', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-shipping-file`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `shipping_list.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const updatePackingItems = createAsyncThunk('updatePackingItems', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/update-packing-items`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadOrders = createAsyncThunk('downloadOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-orders-file`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `orders_file.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const uploadPackingList = createAsyncThunk('uploadPackingList', async (data, {rejectWithValue}) => {

    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/upload-packing-list`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getVendors = createAsyncThunk('getVendors', async (_, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/get-vendors`
    try {
        const response = await axios.get(URL, {})
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getPackingList = createAsyncThunk('getPackingList', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/download-packing-file`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', data?.invoice_number ? `packing_list_${data?.invoice_number}.csv` : `packing_list.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadInboundDetails = createAsyncThunk('downloadInboundDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/download-inbound-details-for-outbound-box`
    try {
        const response = await axios.post(URL, data)
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'sample_sku_mapping_file.xlsx'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename ?? (data?.invoice_number ? `inbound_order_details_${data?.invoice_number}.csv` : `inbound_order_details.csv`));
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadShippingList = createAsyncThunk('downloadShippingList', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/download-shipment-platform-items`
    try {
        const response = await axios.post(URL, data)
        if(response.status === 200){
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `shipping_list.csv`);
            document.body.appendChild(link);
            link.click();
            return response
        }
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const uploadShippingList = createAsyncThunk('uploadShippingList', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/upload-shipment-platform-items`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadSamplePackingList = createAsyncThunk('downloadSamplePackingList', async (_, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-sample-packing-file-shipment-management`
    try {
        const response = await axios.post(URL, {})
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `sample_packing_list.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const uploadShipmentPackingList = createAsyncThunk('uploadShipmentPackingList', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/upload-packing-file-shipment-management/${data.shipment_id}`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getRejectedOrders = createAsyncThunk('getRejectedOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-rejected-oos-orders`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const saveScheduleQuantities = createAsyncThunk('saveScheduleQuantities', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/save-schedule-quantity`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const recoverShipments  = createAsyncThunk('recoverShipments', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/recover-shipment`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
}); 

export const downloadPackingListMyOrders = createAsyncThunk('downloadPackingListMyOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/download-packing-file`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `packing_list.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getShippingLabel = createAsyncThunk('getShippingLabel', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-shipping-label`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'shipping_labels.pdf');
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getDownloadSkusLabel = createAsyncThunk('getDownloadSkusLabel', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-skus-label`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'sku_labels.pdf');
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getQCInwardData = createAsyncThunk('getQCInwardData', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/get-awaiting-inward-boxes`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const inwardBox = createAsyncThunk('inwardBox', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/inward-boxes`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getInwardedBoxes = createAsyncThunk('getInwardedBoxes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/get-inwarded-boxes`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getQcModal = createAsyncThunk('getQcModal', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/get-qc-modal`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const verifyQuantity = createAsyncThunk('verifyQuantity', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/verify-quantity`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const uploadReviewImage = createAsyncThunk('uploadReviewImage', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/upload-review-image`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getReviewCommentMeta = createAsyncThunk('getReviewCommentMeta', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/get-review-comment-meta`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const verifyQCInspection = createAsyncThunk('verifyQCInspection', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/verify-qc-inspection`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const shipToIndiaSummary = createAsyncThunk('shipToIndiaSummary', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/ship-to-india-summary`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const confirmShipToIndia = createAsyncThunk('confirmShipToIndia', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/confirm-ship-to-india`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const returnToVendorSummary = createAsyncThunk('returnToVendorSummary', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/return-to-vendor-summary`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const confirmReturnToVendor = createAsyncThunk('confirmReturnToVendor', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/confirm-return-to-vendor`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadPendingQcInspection = createAsyncThunk('downloadPendingQcInspection', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/download-pending-qc-inspection`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `pending_qc_inspection.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const uploadQcInspectionQuantity = createAsyncThunk('uploadQcInspectionQuantity', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/upload-qc-inspection-quantity-file/${data.box_id}`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const uploadQuantityValidation = createAsyncThunk('uploadQuantityValidation', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/upload-quantity-validation-file/${data.box_id}`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadQcReport = createAsyncThunk('downloadQcReport', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/download-qc-report`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `qc_report.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadPendingQuantityValidation = createAsyncThunk('downloadPendingQuantityValidation', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/download-pending-quantity-validation`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `pending_quantity.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const recoverRejectedOrders  = createAsyncThunk('recoverRejectedOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/vendor/recover-oos-order`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
}); 

export const uploadInwardBoxes = createAsyncThunk('uploadInwardBoxes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/upload-awaiting-inward-file`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getIndiaAwaitingBoxes = createAsyncThunk('getIndiaAwaitingBoxes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/get-awaiting-inward-boxes`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const inwardIndiaBoxes = createAsyncThunk('inwardIndiaBoxes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/receive-boxes`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const receivedIndiaBoxes = createAsyncThunk('receivedIndiaBoxes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/get-received-boxes`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getIndiaQCInspection = createAsyncThunk('getIndiaQCInspection', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/get-qc-inspection`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const indiaUploadRemarks = createAsyncThunk('indiaUploadRemarks', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/upload-review-image`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const indiaGetRemarks = createAsyncThunk('indiaGetRemarks', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/get-review-comment-meta`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const verifyIndiaQcInspection = createAsyncThunk('verifyIndiaQcInspection', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/verify-qc-inspection`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadIndiaQcReport = createAsyncThunk('downloadIndiaQcReport', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/download-qc-report`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `india_qc_report.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const createIndiaPO = createAsyncThunk('createIndiaPO', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/create-purchase-order`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});


export const updateReconciliatedOrders = createAsyncThunk('updateReconciliatedOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/reconcile-rejected-skus`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});


export const getReconciliatedOrders = createAsyncThunk('getReconciliatedOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/get-rejected-skus`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});


export const uploadBulkPackingList = createAsyncThunk('uploadBulkPackingList', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/download-pl-file-box-wise`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }})
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getInvoices = createAsyncThunk('getInvoices', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/get-invoices`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const createReadyForInvoice = createAsyncThunk('createReadyForInvoice', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/create-ready-for-invoice `
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});


export const getBoxesForInvoice = createAsyncThunk('getBoxesForInvoice', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/get-boxes-for-invoice `
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const createInvoice = createAsyncThunk('createInvoice', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/create-invoice`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});


export const downloadInvoice = createAsyncThunk('downloadInvoice', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/download-invoice`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `invoice_${data.invoice_number}.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
})

export const uploadBoxesForInvoice = createAsyncThunk('uploadBoxesForInvoice', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/upload-boxes-for-invoice-creation`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadBoxesForInvoice = createAsyncThunk('downloadBoxesForInvoice', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/qc/china/download-boxes-for-invoice-creation`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `packing_list.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
})


export const downloadInvoiceBoxDetails = createAsyncThunk('downloadInvoiceBoxDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/download-invoice-box-details`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `invoice_boxes_details.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});


export const downloadInvoicePODetails = createAsyncThunk('downloadInvoicePODetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/download-invoice-po-details`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `invoice_${data.invoice_number}_po_details.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});


export const downloadAwaitingInwardBoxes = createAsyncThunk('downloadAwaitingInwardBoxes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/download-awaiting-inward-boxes`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `awaiting_packing_list.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getdownloadSkuLabel = createAsyncThunk('getdownloadSkuLabel', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-view-sku-labels`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
})

export const downloadSkuLabel = createAsyncThunk('downloadSkuLabel', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-sku-labels`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `sku_labels.pdf`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getEditTrackingId = createAsyncThunk('getEditTrackingId', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/get-shipment-details`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
})

export const saveEditTrackingId = createAsyncThunk('saveEditTrackingId', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/vendor/update-shipment-details`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
})


export const getPriceNegotiationDetails = createAsyncThunk('getPriceNegotiationDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/vendor/get-price-negotiation-details`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
})


export const updatePriceNegotiationDetails = createAsyncThunk('updatePriceNegotiationDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/vendor/update-price-negotiation-details`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
})


export const updatePocDetails = createAsyncThunk('updatePocDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/vendor/update-price-negotiation-poc-details`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
})


export const saveManualPriceNegoEntry = createAsyncThunk('saveManualPriceNegoEntry', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/vendor/manual-price-negotiation-entry`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});


export const skipQCInspection = createAsyncThunk('skipQCInspection', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/skip-qc-inspection`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});


export const getOrders = createAsyncThunk('getOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/get-orders`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getOrderActionDraft = createAsyncThunk('getOrderActionDraft', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/get-order-action-draft`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getActionSummary = createAsyncThunk('getActionSummary', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/get-order-action-summary`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});


export const sendToProduction = createAsyncThunk('sendToProduction', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/send-to-production`
    try {

        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'job_card.pdf');
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        // const decoder = new TextDecoder('utf-8')
        // const responseText = decoder.decode(error.response.data)
        // const res = JSON.parse(responseText)
        // if (error.response.status === 401) {
        //     LocalStorage.clear()
        //     window.location.href = '/login'
        // }
        // if (error.response.status !== 200) {
        //     return rejectWithValue({ message: res.message })
        // }
        // return rejectWithValue({message: 'Something went wrong!'})
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const moveOrder = createAsyncThunk('moveOrder', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/move-order`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const indiaSupplyUpdateOrder = createAsyncThunk('updateOrder', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/update-order`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const assignVendors = createAsyncThunk('assignVendors', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/assign-vendors`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getVendorAllocations = createAsyncThunk('getVendorAllocations', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/get-vendor-allocations/${data?.id}`
    try {
        const response = await axios.get(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadOrderFile = createAsyncThunk('downloadInHouseOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/download-order-file`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `india_supply_chain.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const getInventoryDetails = createAsyncThunk('getInventoryDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/inventory/get-inventory-details`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const updateInventoryDetails = createAsyncThunk('updateInventoryDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/inventory/update-inventory-details`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const uploadInventoryFile = createAsyncThunk('uploadInventoryFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/inventory/upload-inventory-file/${data.flow}`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const downloadSampleInventoryFile = createAsyncThunk('downloadSampleInventoryFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/vendor/inventory/download-sample-inventory-file`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Inventory-File.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const updatedelistedDetails = createAsyncThunk('updatedelistedDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/inventory/update-style-status`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        if (error.response.status === 401) {
            LocalStorage.clear()
            window.location.href = '/login'
        }
        if (error.response.status !== 200) {
            return rejectWithValue({ message: error.response.data.message })
        }
        return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const toggleVendorInventorySwitch = createAsyncThunk('toggleVendorInventorySwitch', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/toggle-vendor-inventory-switch`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data?.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateOrderFile = createAsyncThunk('updateOrderFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/update-orders-via-file/${data.path}/status/${data?.order_status}`
    
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file);
    bodyFormData.append('save_draft', !!data?.verticals?.length);
    bodyFormData.append('is_admin', ROLE === 'super_admin' || ROLE === 'admin');
    if (data?.verticals) {
        bodyFormData.append('verticals', JSON.stringify(data?.verticals));
    }

    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadSampleOrderFile = createAsyncThunk('downloadSampleOrderFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/india-supply/download-sample-update-orders-file`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `sampleOrderFile.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getSupplyOrders = createAsyncThunk('getSupplyOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/get-orders`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateProductionStatus = createAsyncThunk('updateProductionStatus', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/update-production-status`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const requestOtp = createAsyncThunk('requestOtp', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/login/request-otp`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const createBox = createAsyncThunk('createShipment', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/create-box`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateAttributes = createAsyncThunk('updateAttributes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/update-sku-dimension-details`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getAttributes = createAsyncThunk('getAttributes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/india/get-sku-dimension-details`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateProductionOnHoldOrders = createAsyncThunk('updateProductionOnHoldOrders', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/update-production-on-hold-orders`
    try {
        // const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        // const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', `challan_details.xlsx`);
        // document.body.appendChild(link);
        // link.click();
        // return response

        if (data.action === 'REJECT') {
            const response = await axios.post(URL, data);
            return response
        } else {
            const response = await axios.post(URL, data)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'job_card.pdf');
            document.body.appendChild(link);
            link.click();
            return response
        }

    } catch (error) {
        // const decoder = new TextDecoder('utf-8')
        // const responseText = decoder.decode(error.response.data)
        // const res = JSON.parse(responseText)
        return handleErrorResponse(error, rejectWithValue)
        // if (error.response.status === 401) {
        //     LocalStorage.clear()
        //     window.location.href = '/login'
        // }
        // if (error.response.status !== 200) {
        //     return rejectWithValue({ message: res.message })
        // }
        // return rejectWithValue({message: 'Something went wrong!'})
    }
});

export const revertOrderAction = createAsyncThunk('revertOrderAction', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/revert-order-action`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getAllGatePasses = createAsyncThunk('getAllGatePasses', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepasses`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getGatePassDetails = createAsyncThunk('getGatePassDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/validate`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getGatePassConfig = createAsyncThunk('getGatePassConfig', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/config`
    try {
        const response = await axios.get(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const confirmGatePassDetails = createAsyncThunk('confirmGatePassDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/details/confirm`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const addDispatchableSkuBox = createAsyncThunk('addDispatchableSkuBox', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/box/add`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateDispatchableSkuBox = createAsyncThunk('updateDispatchableSkuBox', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}bulk-inventory-movement/gatepass/box/update`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getAllGatePassBoxDetails = createAsyncThunk('getAllGatePassBoxDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/boxes `
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getGatePassBoxDetails = createAsyncThunk('getGatePassBoxDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/box/details`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const addGatePassBoxItem = createAsyncThunk('addGatePassBoxItem', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/box/item/add`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const deleteGatePassBoxItem = createAsyncThunk('deleteGatePassBoxItem', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/box/item/delete`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateGatePass = createAsyncThunk('updateGatePass', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/update`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getNonDispatchedItemsDetails = createAsyncThunk('getNonDispatchedItemsDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/non-dispatched-items/details`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateNonDispatchableItem = createAsyncThunk('updateNonDispatchableItem', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/non-dispatched-items/update`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
}); 

export const getGatePassSummary = createAsyncThunk('getGatePassSummary', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}bulk-inventory-movement/gatepass/summary`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const submitGatepass = createAsyncThunk('submitGatepass', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}bulk-inventory-movement/gatepass/submit`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const gatePassReceiveItem = createAsyncThunk('gatePassReceiveItem', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}bulk-inventory-movement/gatepass/item/receive`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const gatePassReceiveBox = createAsyncThunk('gatePassReceiveBox', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}bulk-inventory-movement/gatepass/box/receive`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const completeGatePass = createAsyncThunk('completeGatePass', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/complete`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const printBoxLabels = createAsyncThunk('printBoxLabels', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/bulk-inventory-movement/gatepass/box/print-label`
    try {

        const response = await axios.post(URL, data)
        const link = document.createElement('a');
        
        link.href = response?.data?.data?.label_url;
        link.setAttribute('download', 'box_labels.pdf');
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadVendorOrderFile = createAsyncThunk('downloadVendorOrderFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/download-order-file`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `vendor_orders.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateVendorBulk = createAsyncThunk('updateVendorBulk', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/bulk-update/${data?.status}`

    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file);
    if (data.component_tab)
        bodyFormData.append('component_tab', data.component_tab);
    if (data.component)
        bodyFormData.append('component', data.component);

    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const printBarcodeLabels = createAsyncThunk('printBarcodeLabels', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}barcode-labels`
    try {

        const response = await axios.post(URL, data)
        // const link = document.createElement('a');
        // link.href = response?.data?.data?.label_url;
        // link.setAttribute('download', 'barcode.pdf');
        // document.body.appendChild(link);
        // link.click();

        var printPage = window.open(response?.data?.data?.label_url, '_blank', 'resizable,scrollbars,status');
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getFabrics = createAsyncThunk('getFabrics', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/inventory/get-fabrics`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const createFabric = createAsyncThunk('createFabric', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/fabric/create`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const printSkuLabels = createAsyncThunk('printSkuLabels', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/erp/india-supply/get-sku-labels`
    try {

        // const response = await axios.post(URL, data)
        // var printPage = window.open(response?.data?.data?.label_url, '_blank', 'resizable,scrollbars,status');
        // return response



        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'sku_stickers.pdf');
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});


export const getSkuLabelsChallan = createAsyncThunk('getSkuLabelsChallan', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/get-sku-labels-by-style-action-id`
    try {

        // const response = await axios.post(URL, data)
        // var printPage = window.open(response?.data?.data?.label_url, '_blank', 'resizable,scrollbars,status');

        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'sku_details.pdf');
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const trackUserApiActions = createAsyncThunk('trackUserApiActions', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}/track-user-actions`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateVendor = createAsyncThunk('updateVendor', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/update-vendor`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const inwardBoxToShelf = createAsyncThunk('inwardBoxToShelf', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/inward-box-to-shelf`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});


// product catalogue apis

export const getVendorCatalogues = createAsyncThunk('getVendorCatalogues', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/get-vendor-catalogues`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});


export const uploadProductCatalogue = createAsyncThunk('uploadProductCatalogue', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/upload-bulk-product-launch-file`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    bodyFormData.append('supply_chain', data.supply_chain); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        console.log(error)
        return handleErrorResponse(error, rejectWithValue)
    }
});


export const downloadSampleProductCatalogue = createAsyncThunk('downloadSampleProductCatalogue', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/sample-bulk-product-launch-file`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `sample_product_catalogue.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})


export const downloadVendorCatalogue = createAsyncThunk('downloadVendorCatalogue', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/download-vendor-catalogue-file`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `product_catalogue.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})


export const updateVendorCatalogue = createAsyncThunk('updateVendorCatalogue', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/update-vendor-catalogue`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

// /v1/erp/china/get-bulk-shipping-labels
export const uploadBulkShippingLabels = createAsyncThunk('uploadBulkShippingLabels', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/get-bulk-shipping-labels`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        console.log(error)
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadShipmentFile = createAsyncThunk('downloadShipmentFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/download/download_shipment`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `shipment_orders.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const uploadSampleQcMetadata = createAsyncThunk('uploadSampleQcMetadata', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/china/upload-sample-qc-metadata`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getAllMaterialIds = createAsyncThunk('getAllMaterialIds', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/material/get-all-material-ids`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const uploadGarmentSpecificationFile = createAsyncThunk('uploadGarmentSpecificationFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/inventory/upload-garment-file`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateStyleDetails = createAsyncThunk('updateStyleDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/update-vendor-attributes-from-ui`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getStyleDetails = createAsyncThunk('getAllMaterialIds', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/get-style-details`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadStyleSurveyFile = createAsyncThunk('downloadStyleSurveyFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india/download-style-survey-file`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `sample_survey_file.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const uploadStyleSurveyDesignFile = createAsyncThunk('uploadStyleSurveyDesignFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india/ingest-style-survey-designs`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    bodyFormData.append('supply_chain', data.supply_chain); 
    bodyFormData.append('vendor_catalogue_id', data.vendor_catalogue_id); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const uploadGradingFile = createAsyncThunk('uploadGradingFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/inventory/upload-grading-file`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    bodyFormData.append('supply_chain', data.supply_chain); 
    bodyFormData.append('vendor_catalogue_id', data.vendor_catalogue_id); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateSkuFabricMapping = createAsyncThunk('updateSkuMaterialMapping', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/update-sku-material-mapping/product_fabric`
    try {
        console.log(data)
        if (data?.request_type === 'download_sample_file') {
            const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
            const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `sample_sku_mapping_file.xlsx`);
            document.body.appendChild(link);
            link.click();
            return response
        } else if (data?.request_type === 'update' || data?.request_type === 'create') {
            let bodyFormData = new FormData();
            Object.entries(data)?.forEach(([key, value]) => {
                bodyFormData.append(key, value)
            })
            // const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }})
            const response = await axios.post(URL, bodyFormData, { headers: { "Content-Type": "multipart/form-data" }, 'responseType': 'arraybuffer'})
            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = 'uploaded_sample_sku_map_file.xlsx'; // Default filename if none is found
            if (contentDisposition && contentDisposition.includes('attachment')) {
                const matches = /filename=([^"]*)/.exec(contentDisposition);
                if (matches != null && matches[1]) {
                filename = matches[1];
                }
            }
            const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${filename}`);
            document.body.appendChild(link);
            link.click();
            return response
        }
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadSkuFabricMapping = createAsyncThunk('downloadSkuFabricMapping', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/download-sku-material-mapping/product_fabric`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'sample_sku_mapping_file.xlsx'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getPreStockListing = createAsyncThunk('getPreStockListing', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/get-pre-stock-listing`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadPreStockListing = createAsyncThunk('downloadPreStockListing', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/download-pre-stock-listing`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'pre_stock_listing.csv'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});



export const downloadSampleFile = createAsyncThunk('downloadSampleFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/download-sample-file`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'pre_stock_listing.csv'; // Default filename if none is found
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const ingestVendorSplitFile = createAsyncThunk('ingestVendorSplitFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/ingest-vendor-split-file`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file);
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const bulkUploadInwardBoxes = createAsyncThunk('bulkUploadInwardBoxes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/get-bulk-awaiting-inward-boxes`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    bodyFormData.append('supply_chain', data.supply_chain); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        console.log(error)
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadAwaitingInwardBoxesFile = createAsyncThunk('downloadAwaitingInwardBoxesFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/download-awaiting-inward-boxes-file`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Sample-bulk-upload.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const uploadInvoice = createAsyncThunk('uploadInvoice', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/upload-invoice`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    bodyFormData.append('po_number', data.po_number); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        console.log(error)
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadSampleMeasurementFile = createAsyncThunk('downloadSampleMeasurementFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/download-sample-measurement-file`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Sample-measurements.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})

export const downloadSampleCostingFile = createAsyncThunk('downloadSampleCostingFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india/download-sample-costing-file`
    try {
        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const url = window.URL.createObjectURL(new Blob([response.data],{ type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Sample-Costing.xlsx`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})

export const sampleMeasurementData = createAsyncThunk('sampleMeasurementData', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india/save-sample-measurement-data-ui`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateSampleCostingDataUi = createAsyncThunk('updateSampleCostingDataUi', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india/save-sample-costing-data-ui`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const uploadSampleMeasurementsFile = createAsyncThunk('uploadSampleMeasurementsFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india/upload-sample-measurement-details-file`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    bodyFormData.append('vendor_catalogue_id', data.vendor_catalogue_id); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        console.log(error)
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadInvoiceProductDetailsFile = createAsyncThunk('downloadInvoiceProductDetailsFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/download-invoice-product-details`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Product-details.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const uploadSampleCostingFile = createAsyncThunk('uploadSampleCostingFile', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india/upload-sample-costing-file`
    let bodyFormData = new FormData();
    bodyFormData.append('file', data.file); 
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        console.log(error)
        return handleErrorResponse(error, rejectWithValue)
}
});

export const revertBoxToQc = createAsyncThunk('revertBoxToQc', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/revert-box-to-qc`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateCreateExportOrder = createAsyncThunk('updateCreateExportOrder', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/create-export-order`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const createNewUser = createAsyncThunk('createNewUser', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/create-user`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getUserDetails = createAsyncThunk('getUserDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/get-users`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getDefaultConfig = createAsyncThunk('getDefaultConfig', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/get-sidemenu`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getUsersDetails = createAsyncThunk('getUsersDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/get-user-details`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const updateUser = createAsyncThunk('updateUser', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/update-user`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const exportVendorCatalogue = createAsyncThunk('exportVendorCatalogue', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/china/create-export-assortments-job`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})

export const getStoreConfig = createAsyncThunk('getStoreConfig', async (_, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}offline-inventory/config`
    try {
        const response = await axios.get(URL, {})
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const getProductInventory = createAsyncThunk('getProductInventory', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/inventory/get-product-inventory`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const downloadInventoryDetails = createAsyncThunk('downloadInventoryDetails', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/vendor/inventory/download-inventory-details`
    try {
        const response = await axios.post(URL, data)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Inventory-Details.csv`);
        document.body.appendChild(link);
        link.click();
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});


export const updatePassword = createAsyncThunk('updatePassword', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/change-password`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})

export const getVendorInwardedBoxes = createAsyncThunk('getVendorCatalogues', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/get-china-qc-reports`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const revertQualityInspection = createAsyncThunk('revertQualityInspection', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/revert-styles-to-quality-inspection`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const createPreProductionOrder = createAsyncThunk('createPreProductionOrder', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india/create-pre-production-order`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})

export const getGateEntries = createAsyncThunk('getGateEntries', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/gate-entry/get-orders`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})

export const createGateEntries = createAsyncThunk('createGateEntries', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/gate-entry/create`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})

export const getPutaway = createAsyncThunk('getPutaway', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/putaway/get-orders`
    try {
        const response = await axios.post(URL, data)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
})

export const createPutawayItem = createAsyncThunk("createPutawayItem", async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/putaway/create-putaway-item`;
    try {
      const response = await axios.post(URL, data);
      return response;
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue);
    }
  }
);

export const getPutawayMaterials = createAsyncThunk("getPutawayMaterials", async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/putaway/get-putaway-materials`;
    try {
      const response = await axios.post(URL, data);
      return response;
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue);
    }
  }
);

export const dispatchOrders = createAsyncThunk("dispatchOrders", async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/dispatch/create`;
    try {
        const response = await axios.post(URL, data);
        return response;
    }
    catch (error) {
        return handleErrorResponse(error, rejectWithValue);
    }
})

export const getPicklist = createAsyncThunk("getPicklist", async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/mo/get-orders`;
    try {
        const response = await axios.post(URL, data);
        return response;
    }
    catch (error) {
        return handleErrorResponse(error, rejectWithValue);
    }
})

export const createPickList = createAsyncThunk("createPickList", async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/picklist/create`;
    try {

        const response = await axios.post(URL, data, { 'responseType': 'arraybuffer'})
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'created_picklist.xlsx';
        if (contentDisposition && contentDisposition.includes('attachment')) {
            const matches = /filename=([^"]*)/.exec(contentDisposition);
            if (matches != null && matches[1]) {
            filename = matches[1];
            }
        }
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${filename}`);
        document.body.appendChild(link);
        link.click();
        return response
    }
    catch (error) {
        return handleErrorResponse(error, rejectWithValue);
    }
})
